// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Q8e7","rightAdornment":"Header_rightAdornment__2eCWG"};